import { AxiosResponse } from 'axios';
import { apiClient } from '../instance';
import {
  CheckAvailabilityResponse,
  TokenResponse,
  User,
} from '../../types/interfaces';

export const authApi = {
  checkEmailAvailable: (
    email: string
  ): Promise<AxiosResponse<CheckAvailabilityResponse>> =>
    apiClient.get<CheckAvailabilityResponse>('auth/check_email_available/', {
      params: { email },
    }),
  getMe: (): Promise<AxiosResponse<User>> => apiClient.get<User>('users/me/'),

  updateMe: (data: Partial<User> | FormData): Promise<AxiosResponse<User>> =>
    apiClient.patch<User>('users/me/', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    }),

  checkUsernameAvailable: (
    username: string
  ): Promise<AxiosResponse<CheckAvailabilityResponse>> =>
    apiClient.get<CheckAvailabilityResponse>('auth/check_username_available/', {
      params: { username },
    }),


  login: (
    username: string,
    password: string
  ): Promise<AxiosResponse<TokenResponse>> =>
    apiClient.post<TokenResponse>('auth/token/', { username, password }),

  logout: (): Promise<AxiosResponse<void>> => apiClient.get('auth/logout/'),

  confirmEmail: (code: string): Promise<AxiosResponse<void>> =>
    apiClient.get<void>('auth/confirm_email/', { params: { code } }),

  passwordResetRequest: (data: { email: string }): Promise<AxiosResponse<void, any>> =>
    apiClient.put<void>('auth/reset_password/', data),

  resetPassword: (data: { code: string, new_password: string }): Promise<AxiosResponse<void>> =>
    apiClient.post('auth/reset_password/', data),

  updatePassword: (data: { old_password: string, new_password: string }): Promise<AxiosResponse<void>> =>
    apiClient.post('users/update_password/', data),

  // Двухшаговая смена email. Шаг 1 шлёт код на ТЕКУЩУЮ почту юзера
  // (без раскрытия, существует ли new_email в системе). Шаг 2 принимает
  // код и применяет смену. После confirm бэк инвалидирует все токены
  // юзера — фронту надо обновить /me/ и при необходимости заставить
  // переавторизоваться (Auth-токен в localStorage больше невалиден).
  // См. personal_area/views/users.py: request_email_change / confirm_email_change.
  requestEmailChange: (
    data: { new_email: string }
  ): Promise<AxiosResponse<{ detail: string }>> =>
    apiClient.post('users/request_email_change/', data),

  confirmEmailChange: (
    data: { code: string }
  ): Promise<AxiosResponse<User>> =>
    apiClient.post<User>('users/confirm_email_change/', data),

  // Двухшаговая смена логина — то же flow, что у email: код приходит
  // на ТЕКУЩУЮ почту юзера, не на новый логин. После confirm бэк
  // инвалидирует все токены — фронту надо обновить /me/ (или дойти
  // до 401 и редиректнуть на login).
  // См. personal_area/views/users.py: request_username_change /
  // confirm_username_change.
  requestUsernameChange: (
    data: { new_username: string }
  ): Promise<AxiosResponse<{ detail: string }>> =>
    apiClient.post('users/request_username_change/', data),

  confirmUsernameChange: (
    data: { code: string }
  ): Promise<AxiosResponse<User>> =>
    apiClient.post<User>('users/confirm_username_change/', data),

  register: (data: {
    username: string;
    email: string;
    password: string;
    first_name?: string;
    last_name?: string;
    patronymic?: string;
    mobile_phone?: string;
    /** Отметки согласий (ПДн обязательно, рассылки — по желанию) и версия текста. */
    consent_personal_data?: boolean;
    consent_marketing?: boolean;
    consent_version?: string;
  }): Promise<AxiosResponse<User>> =>
    apiClient.post<User>('users/register/', data),

  /** Удаление своего аккаунта (подтверждение паролем). 204 — удалён. */
  deleteAccount: (password: string): Promise<AxiosResponse<void>> =>
    apiClient.post('users/delete_account/', { password }),

};
